<template>
<el-dropdown class='nav selector' menu-align='start' :hide-on-click="false">
  <span class="el-dropdown-link">{{ category ? category.name : $t('actions.category.all') }}<i class="ppj-icon-down-dir"></i></span>
  <el-dropdown-menu class='primary-dropdown' slot="dropdown">
    <el-dropdown-item>
      <router-link to="/" class='item' tag='div' exact>{{$t('actions.category.all')}}</router-link>
    </el-dropdown-item>
    <el-dropdown-item :divided="index === 0" v-for="(cat, index) in categories" :key='cat.id'>
      <router-link class='item' :to="{name: 'category', params: {id: cat.id}}" tag='div'>{{cat.name}}</router-link>
    </el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>
</template>

<script>
export default {
  props: ['category', 'categories']
}
</script>

<style lang="scss" scoped>
.selector {
    .el-dropdown-link {
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// selector.vue?67b9c988